import { getClassName } from '@perpay-web/utils/domUtils';
import { noop } from '@perpay-web/utils/noop';

import styles from './RadioButton.scss';

export const StatelessRadioButton = ({
    isActive,
    className = '',
    onClick = noop,
    children,
    ...rest
}) => (
    <button
        className={getClassName(
            className,
            styles['radio-button'],
            isActive && styles['radio-button--checked'],
        )}
        onClick={onClick}
        type='button'
        {...rest}
    >
        <div className={styles.radio} />
        {children}
    </button>
);

const RadioButton = ({
    field: { value, name },
    children,
    setFieldValue,
    radioValue,
    className = '',
    ...rest
}) => (
    <StatelessRadioButton
        className={className}
        isActive={value === radioValue}
        onClick={() => setFieldValue(name, radioValue)}
        {...rest}
    >
        {children}
    </StatelessRadioButton>
);

export default RadioButton;
